import { ofType } from 'redux-observable';
import { mergeMap, map, filter } from 'rxjs';
import { AppEpic } from 'src/store';
import { of } from 'rxjs';
import { updateFlowStatus } from 'src/components/Subheader/Subheader.slice';
import { updateGroupBy, receiveViewDefns } from 'src/components/Subheader/Subheader.slice';
import { getGroupBy } from 'src/components/Subheader/Subheader.selectors';
import { fetchProductMixData, receiveViewDefn } from './ProductMix.slice';
import {
  inputIsNotNullOrUndefined,
  isScopeDefined,
  isSubheaderLoaded,
  maybeGetComponentProps,
} from 'src/utils/Functions/epicsFunctions';
import { ConfDefnComponentType, ProductMixComponent } from 'configuration-schemas/confdefnComponents';
import {
  ExtraPivotOptions,
  getAggBys,
  getConfigureModalAggBys,
  organizeListDataOptions,
} from 'src/pages/Hindsighting/StyleColorReview/StyleColorReview.slice';
import { DataApi } from 'configuration-schemas/confdefnView';
import { LEVEL_PROD_ROOT } from 'src/utils/Domain/Constants';
import {
  receiveScopeConfig,
  receiveScopeRefreshTrigger,
} from 'src/components/AssortmentScopeSelector/AssortmentScopeSelector.slice';
import { receiveFilterStateAfterSubmission } from 'src/components/FilterPanel/FilterPanel.slice';
import { updateSelectedItem as worklistUpdateSelectedItem } from 'src/pages/Worklist/Worklist.slice';
import { LENS_ASST_PLAN_REFRESHING_PAGE } from 'src/pages/AssortmentBuild/Planning.types';

export const productMixLoad: AppEpic = (action$, state$) => {
  return action$.pipe(
    ofType(
      receiveScopeRefreshTrigger.type,
      receiveFilterStateAfterSubmission.type,
      receiveViewDefns.type,
      updateFlowStatus.type,
      updateGroupBy.type,
      receiveViewDefn.type,
      receiveScopeConfig.type,
      worklistUpdateSelectedItem.type,
      LENS_ASST_PLAN_REFRESHING_PAGE,
    ),
    map(() => maybeGetComponentProps<ProductMixComponent>(state$.value, ConfDefnComponentType.productMix)),
    filter(inputIsNotNullOrUndefined),
    filter(() => isScopeDefined(state$.value.scope) && isSubheaderLoaded(state$.value.subheader)),
    mergeMap(({ defns, topMembers }) => {
      const flowStatus = state$.value.subheader.flowStatus.join(',');

      // TODO: move this to config when ready
      const dataApi: DataApi = {
        defnId: defns.model,
        isListData: true,
        params: {
          aggBy: '',
          topAggBy: LEVEL_PROD_ROOT,
          topMembers,
        },
      };

      // need to get current groupBy selection from subheader (minus the default bottom level)
      // and apply a topAggBy from the DataApi config.
      // to be clear there is no configure modal on this screen, just using this for the topAggBy logic
      const currentAggBy = getAggBys(getGroupBy(state$.value), dataApi, {
        includeBottomLevel: false,
        forceReload: true,
        groupingKeyOverride: 'dataIndex',
      });
      const finalAggBy = getConfigureModalAggBys([currentAggBy], dataApi);

      const options: ExtraPivotOptions = { flowStatus, aggBy: finalAggBy };
      const finalOptions = organizeListDataOptions(options, dataApi);

      return of(fetchProductMixData(defns.model, finalOptions));
    }),
  );
};
